import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    overflowX: 'auto',
    overflowY: 'hidden',
    width: '100vw',
    height: 'calc(100dvh - 111px)',
    // 111px for top and bottom bar height,
  },
  card: {
    flexShrink: '0',
    width: 335,
    height: 515,
    borderRadius: '10px',
    margin: theme.spacing(1, 2),
    alignSelf: 'center',

    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 159px)',
      // 111px for top and bottom bar height, 48px for spacing, equals 159px
      maxHeight: 515,
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
      marginLeft: 'calc((100vw - 300px)/2)',
      marginRight: 'calc((100vw - 300px)/2)',
    },
  },

  root: {
    flexGrow: 1,
    padding: '15px 0 15px 0',
  },
  widget: {
    width: 335,
    height: 515,
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    backgroundColor: theme.palette.backgroundColor.secondary,

    [theme.breakpoints.down(769)]: {
      width: 335,
      height: 'calc(100dvh - 159px)',
      // 111px for top and bottom bar height, 48px for spacing, equals 159px
      maxHeight: 515,
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  header: {
    padding: theme.spacing(1.1),
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '1.1rem',
    color: theme.palette.primary.main,
    paddingLeft: 10,
  },
  divider: {
    backgroundColor: theme.palette.primary.main,
    height: 1.5,
  },
  content: {
    position: 'relative',
    width: 335,
    height: '100%',
    maxHeight: 478,
    overflow: 'clip',
    borderRadius: theme.spacing(0.5),
    overflowY: 'auto',
    [theme.breakpoints.down(769)]: {
      width: 335,
      height: 'calc(100dvh - 196px)',
      // 111px for top and bottom bar height, 48px for spacing,
      // 37px for widget title header equals 196px
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  contentNoOverflowY: {
    overflowY: 'hidden',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
  },
  row: {
    padding: theme.spacing(1.5),
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
  },
  spacer: {
    height: theme.spacing(1.5),
  },
  profileDeepLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0.5),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.button.hover,
    },
    '&:focus-visible': {
      backgroundColor: theme.palette.button.hover,
    },
  },
  tabLinkBox: {
    width: 80,
    height: 70,
    textAlign: 'center',
    margin: '0 auto',
  },
  tabLinkText: {
    fontWeight: 400,
    margin: 0,
    maxHeight: 26,
    maxWidth: 80,
    padding: '0 3px',
    fontSize: '10px',
    overflow: 'hidden',
    display: '-webkit-box',
    lineHeight: 1.3,
    '-webkit-line-clamp': 2,
    'line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  removeWidgetIcon: {
    width: 20,
    height: 20,
    marginRight: 4,
  },
  removeWidgetHighlight: {
    fontSize: 20,
    color: theme.palette.primary.main,
  },
  mobileGlanceMenu: {
    position: 'fixed',
    zindex: 1000,
    top: 55,
    left: 0,
    right: 0,
    bottom: 55,
    width: '0px',
  },
  textCenter: {
    flex: '1 1 auto',
  },
  proxyModeContainer: {
    backgroundColor: 'rgba(0,0,0,.85)',
    paddingTop: 20,
  },
  proxyModeText: {
    marginTop: 20,
    color: theme.palette.primary.main,
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '10px',
    alignItems: 'center',
  },
  linkContainerStroke: {
    borderBottom: `1px solid ${theme.palette.base.lightGray}`,
  },
  linkButtonDiv: {
    padding: 4,
    height: 50,
  },
  linkButton: {
    width: '100%',
    height: '100%',
  },
}))

export default styles
